import { Flex, Icon, MenuDivider, MenuItem } from '@chakra-ui/react';
import { useOktaAuth } from '@okta/okta-react';
import { ResReHeader } from '@resolutionlife/ui';
import { FaUsersCog } from 'react-icons/fa';
import { FaFileMedicalAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { DownloadPiiReportMenuItem } from '../components/download-pii-report/download-pii-report';

import { FileSearchAutoComplete } from '../components/file-search-autocomplete/file-search-autocomplete';

import { useAppConfig } from '../context/app-config-context/app-config-context';
import { navigateToProlematicFilesPage } from '../pages/problematic-files-page/problematic-files-page';
import { navigateToUserManagementPage } from '../pages/user-management-page/user-management-page';

const UserManagementMenuItem: React.FC = () => {
  return (
    <MenuItem
      as={Link}
      to={navigateToUserManagementPage()}
      data-testid="user-management-menu-item"
    >
      <Icon as={FaUsersCog} mr={2} fontSize="16" color="gray.700" />
      User Management
    </MenuItem>
  );
};

const ProblematicFilesMenuItem: React.FC = () => {
  return (
    <MenuItem
      as={Link}
      to={navigateToProlematicFilesPage()}
      data-testid="problematic-files-menu-item"
    >
      <Icon as={FaFileMedicalAlt} mr={2} fontSize="16" color="gray.700" />
      Problematic Files
    </MenuItem>
  );
};

export const DefaultLayout: React.FC = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const userInfo =
    (authState?.idToken?.claims as {
      name?: string;
      preferred_username?: string;
      email?: string;
    }) || {};
  const userName = userInfo.name || userInfo.preferred_username || 'John Doe';

  const handleLogout = async () => {
    try {
      await oktaAuth.signOut();
    } catch (error) {
      // Error during logout
    }
  };
  const {
    canManageUsers,
    canDownloadPiiReport,
    canViewProblemFiles,
  } = useAppConfig();

  const menuItems = [];

  if (canManageUsers) {
    menuItems.push(
      ...[
        <MenuDivider key="divider-1" />,
        <UserManagementMenuItem key="user-management-menu-item" />,
      ]
    );
  }

  if (canDownloadPiiReport) {
    menuItems.push(
      ...[
        <MenuDivider key="divider-2" />,
        <DownloadPiiReportMenuItem key="download-pii-report-menu-item" />,
      ]
    );
  }

  // Always show problematic files menu item if user has permission
  if (canViewProblemFiles) {
    menuItems.push(
      ...[
        <MenuDivider key="divider-3" />,
        <ProblematicFilesMenuItem key="problematic-files-menu-item" />,
      ]
    );
  }

  return (
    <Flex as="main" flex="1" minHeight="100vh" direction="column" bg="white">
      <ResReHeader
        user={{ name: userName, email: userInfo.email }}
        onLogout={handleLogout}
        Accessories={[<FileSearchAutoComplete key="file-search-autocomplete" />]}
        MenuItems={menuItems}
      />
      {children}
    </Flex>
  );
};
